import { lazy } from 'react';
import '../../styles.css';

const App = lazy(() => import('../App/App'));

const MicroApp = ( props: {
	externalAppInfo?: {
		externalFloSpaceId: string;
	};
	renderCompleteCb?: Function;
}) => <App {...props} />;

export default MicroApp;